import styled from 'styled-components';
import type {
  ThemeType,
} from '@n3/css-base';

const getToggleBackgroundColor = (
  checked: boolean,
  disabled: boolean,
  theme: ThemeType,
): string => {
  if (disabled) {
    return checked ? theme.colors.MISCELLANEOUS_TOGGLE_ON_DISABLED : theme.colors.BUTTON_DISABLED;
  }

  if (checked) {
    return theme.colors.SUPPORT_SUCCESS;
  }

  return theme.colors.MISCELLANEOUS_TOGGLE_OFF;
};

const getToggleCircleColor = (
  disabled: boolean,
  theme: ThemeType,
): string => {
  if (disabled) {
    return theme.colors.ICON_DISABLED;
  }

  return theme.colors.NEUTRAL_WHITE;
};

const getSvgIconColor = (disabled: boolean, theme: ThemeType): string => {
  if (disabled) {
    return theme.colors.ICON_ON_COLOR_DISABLED;
  }

  return theme.colors.SUPPORT_SUCCESS;
};

export const StyledRoot = styled.div({});
export const StyledLabel = styled.label({
  cursor: 'pointer',
});
export const StyledRealLabel = styled.span<{ $disabled: boolean }>(({
  $disabled,
  theme: { fonts, colors },
}) => ({
  ...fonts.LABEL,
  display: 'inline-block',
  marginBottom: '8px',
  color: $disabled ? colors.TEXT_DISABLED : colors.TEXT_PRIMARY,
}));
export const StyledInput = styled.input({
  opacity: 0,
  position: 'absolute',
});
export const StyledToggleCircle = styled.span({});

export type StyledToggleProps = {
  $isSmall: boolean;
  $checked: boolean;
  $disabled: boolean;
};

export const StyledToggleWrapper = styled.div({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
});

export const StyledToggle = styled.div<StyledToggleProps>(({
  $isSmall,
  $checked,
  $disabled,
  theme,
}) => ({
  boxSizing: 'border-box',
  display: 'inline-block',
  position: 'relative',
  width: $isSmall ? '32px' : '48px',
  height: $isSmall ? '16px' : '24px',
  background: getToggleBackgroundColor($checked, $disabled, theme),
  borderRadius: '12px',
  padding: '3px',

  [`${StyledToggleCircle}`]: {
    position: 'absolute',
    left: '3px',
    top: '50%',
    width: $isSmall ? '10px' : '18px',
    height: $isSmall ? '10px' : '18px',
    background: getToggleCircleColor($disabled, theme),
    borderRadius: '50%',
    transform: $checked ? $isSmall ? 'translate(16px, -50%)' : 'translate(24px, -50%)' : 'translate(0, -50%)',
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',

    '& svg': {
      fill: getSvgIconColor($disabled, theme),
    },
  },
}));

export const StyledValue = styled.div<{ $disabled: boolean }>(({
  theme: { fonts, colors },
  $disabled,
}) => ({
  ...fonts.DEFAULT_COMPACT,
  color: $disabled ? colors.TEXT_DISABLED : colors.TEXT_PRIMARY,
}));
